module.exports = __webpack_public_path__ + "img/MedicalHistory.be7f0696.svg";